module.exports = __webpack_public_path__ + "img/product-img6.d9bd3953.jpg";